import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Higer Order Components
import TimeAgo from 'timeago-react';

import EditImageModal from '../edit-image-modal/EditImageModal.jsx';

import s from './UploadedImage.module.scss';

export default class UploadedImage extends Component {
    static propTypes = {
        image: PropTypes.object,
        editAltText: PropTypes.func,
        accountId: PropTypes.string,
        openImageInNewTab: PropTypes.func,
    };

    static defaultProps = {
        image: {},
        editAltText: () => {},
        accountId: '',
        openImageInNewTab: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = { isOpen: false };
    }

    closeModal = () => this.setState({ isOpen: false });

    openModal = () => this.setState({ isOpen: true });

    onGetWhenUploaded = size => {
        const { image } = this.props;

        const datetime = image.dateUploaded ? image.dateUploaded : new Date(Date.now());

        const divStyle = {
            fontSize: size,
            fontWeight: 500,
        };

        return <TimeAgo style={divStyle} datetime={datetime} live={false} />;
    };

    renderImageModal = () => {
        const { image, editAltText, accountId, openImageInNewTab } = this.props;
        const { isOpen } = this.state;
        return (
            <EditImageModal
                image={image}
                dateUploaded={this.onGetWhenUploaded('12px')}
                editAltText={editAltText}
                okLabel="UPDATE IMAGE"
                cancelLabel="CANCEL"
                onClose={this.closeModal}
                open={isOpen}
                accountId={accountId}
                openImageInNewTab={openImageInNewTab}
            />
        );
    };

    render() {
        const { image, accountId } = this.props;
        return (
            <div className={classNames(s.uploadedFileContainer, s.imgChildContainer)}>
                <button className={s.editModalBtn} type="button" aria-label="Edit image" onClick={this.openModal}>
                    <div className={classNames(s.editImg, 'icon-information')} />
                </button>
                <div className={s.imgDimensions}>
                    <img className={s.fileImg} src={image.uri || `https://img.locuslabs.com/resize/${accountId}/137x105cc/poi/${image.blobId}`} alt={image.caption} />
                </div>
                <div className={s.caption}>{image.caption || image.blobId}</div>
                {this.renderImageModal()}
            </div>
        );
    }
}
